<template>
  <div v-if="bannerData" :class="['w-full text-center p-4 text-gray-900 sticky', bannerData.bgClass]">
    <div class="flex items-center justify-center">
      <i :class="[bannerData.icon, 'mr-2']" aria-hidden="true"></i>
      <p class="font-bold text-lg">{{ bannerData.title }}</p>
    </div>

    {{ bannerData.message }}
  </div>
</template>

<script>
export default {
  props: {
    variantPayload: {
      type: Object,
      required: false,
      default: null
    }
  },
  computed: {
    bannerData() {
      return this.variantPayload || null;
    }
  }
};
</script>
